import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const HamburgerMenuWrapperStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "hamburger-menu",
})`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
